module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/define-property.js
// module id = C4MV
// module chunks = 61 62 63 64 65 66 67 68 69 70 71 72 73 74 75